import React from "react"
import { CustomLogo } from "../../Headers/CustomLogo"
import { Halvenok } from "../../Headers/Logos/Halvenok"

export function HalvenokLogo() {
  return <CustomLogo withButton={false} Logo={Halvenok} />
}
